<template>
  <div id="app" :class="{'theme-light' : lightMode}">
    <webapp-header />
    <router-view/>
    <webapp-footer />
    <nav class="theme-mode">
      <i class="fas fa-moon" v-if="lightMode" @click="lightMode =!lightMode"></i>
      <i class="fa fa-sun" v-else @click="lightMode =!lightMode"></i>
    </nav>
  </div>
</template>

<script>
 import appHeader from './components/appHeader.vue'
 import appFooter from './components/appFooter.vue' 

export default {
  name: 'App',
  components: {
    'webapp-header':appHeader,
    'webapp-footer':appFooter
  },
  data() {
    return {
      lightMode: false
    }
  },
  watch: {
    lightMode: function(){
      localStorage.setItem("lightMode", JSON.stringify(this.lightMode));
    }
  },
  created() {
    this.lightMode = JSON.parse(localStorage.getItem("lightMode"));
  }
}
</script>

<style lang="scss">
@import 'styles/libraries';
@import 'styles/global';
@import url("https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.2/animate.min.css");
// @import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.13.0/css/all.min.css");
</style>
